module.exports = __webpack_public_path__ + "static/media/AutoCAD Electrical.0b1e48b1.png";